import React from "react";
import { inject, observer } from "mobx-react/index";
import Spinner from "../../Spinner";
import { Link } from "react-router";
import DataTable from "../../DataTable";

@inject(
  "eventTypeStore",
  "eventStore",
  "stationStore",
  "userStore",
  "ticketStatusStore",
  "ticketReasonStore",
  "ticketActionStore",
  "qcCheckStore"
)
@observer
class EventList extends React.Component {
  componentWillMount() {
    const {
      eventTypeStore,
      eventStore,
      stationStore,
      userStore,
      ticketStatusStore,
      ticketReasonStore,
      ticketActionStore,
      qcCheckStore,
    } = this.props;
    if (!eventTypeStore.items.length) eventTypeStore.fetchItems();
    if (!eventStore.items.length) eventStore.fetchItems();
    if (!stationStore.items.length) stationStore.fetchItems();
    if (!userStore.items.length) userStore.fetchItems();
    if (!ticketStatusStore.items.length) ticketStatusStore.fetchItems();
    if (!ticketReasonStore.items.length) ticketReasonStore.fetchItems();
    if (!ticketActionStore.items.length) ticketActionStore.fetchItems();
    if (!qcCheckStore.items.length) qcCheckStore.fetchItems();
  }

  handleDelete = (id) => {
    this.props.eventStore.removeItems(id);
  };

  flattenData = () => {
    const {
      eventStore,
      ticketActionStore,
      ticketStatusStore,
      ticketReasonStore,
      userStore,
      eventTypeStore,
    } = this.props;

    const result = [];
    eventStore.items.forEach((element, index) => {
      const status = ticketStatusStore.findById(element.status_id);
      const reason = ticketReasonStore.findById(element.reason_id);
      const action = ticketActionStore.findById(element.action_id);
      const user = userStore.findById(element.assigned_to);
      const eventType = eventTypeStore.findById(element.event_type);

      result.push({
        key: `event-ticket-${element.id}`,
        type: "event",
        level: 1,
        caption: element.caption,
        event_type: eventType && eventType.type,
        max_occurrence: element.max_occurrence,
        duration: element.duration,
        id: element.id,
        slug: "/monitoring/event/list",
        summary: element.summary,
        status: status && status.caption,
        reason: reason && reason.caption,
        action: action && action.caption,
        assigned_to: user && user.name,

        tickets: (
          <ul>
            <li key={`${element.id}`}>
              <Link to={`/monitoring/event/${element.id}/ticket`}>Tickets</Link>
            </li>
          </ul>
        ),
      });
    });
    return result;
  };

  render() {
    if (
      this.props.eventStore.isLoading ||
      this.props.eventTypeStore.isLoading ||
      this.props.stationStore.isLoading ||
      this.props.userStore.isLoading ||
      this.props.ticketActionStore.isLoading ||
      this.props.ticketReasonStore.isLoading ||
      this.props.ticketStatusStore.isLoading ||
      this.props.qcCheckStore.isLoading
    ) return <Spinner />;

    const data = this.flattenData();

    return (
      <div>
        <DataTable
          columns={[
            { key: "id", label: "ID" },
            { key: "caption", label: "Caption" },
            { key: "event_type", label: "Type" },
            { key: "max_occurrence", label: "Max Occurrence" },
            { key: "duration", label: "Duration (min)" },
            { key: "tickets", label: "Tickets" },
            { key: "summary", label: "Summary" },

            { key: "status", label: "Status" },
            { key: "reason", label: "Reason" },
            { key: "assigned_to", label: "Assign to" },
          ]}
          data={data}
          slug={"monitoring/event/list"}
          allowAdd
          allowEdit
          allowDelete
          onDelete={this.handleDelete}
          disableMultipleDelete
        />
        {this.props.children}
      </div>
    );
  }
}

export default EventList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Event/EventList.js